import React, {useContext, useEffect} from 'react'
import NoticeTextInput from "../../components/inputs/NoticeTextInput";
import NoticeGlossaryInput from "../../components/inputs/NoticeGlossaryInput";
import FormTranslationContext from "context/FormTranslationContext";
import getObjectValue from "libs/getObjectValue";
import {Collapse} from "@material-ui/core";

function PurchaserDataEntrusted(
    {
        id,
        formikProps
    }) {

    const gId = (name) => id + "." + name;
    const gVal = (name, prefix = true, defaultVal = null) => getObjectValue(prefix ? gId(name) : name, formikProps.values, defaultVal);
    const {getDict} = useContext(FormTranslationContext)

    useEffect(() => {
        if (getObjectValue(id, formikProps.values, null) == null) {
            formikProps.setFieldValue(id, {})
        }
        // eslint-disable-next-line
    }, [])

    return (<>
        <NoticeTextInput
            formikProps={formikProps}
            id={gId("name")}
            required
        />
        <NoticeTextInput
            formikProps={formikProps}
            id={gId("nationalIdNumber")}
            required
        />
        <NoticeTextInput
            formikProps={formikProps}
            id={gId("street")}
            required
        />
        <NoticeTextInput
            formikProps={formikProps}
            id={gId("city")}
            required
        />
        <NoticeTextInput
            formikProps={formikProps}
            id={gId("postCode")}
            required
        />
        <NoticeGlossaryInput
            formikProps={formikProps}
            id={gId("country")}
            items={getDict("SL.MT.005")}
            required
            unmountOnExit
        />
        <Collapse in={gVal("country") === "PL"}>
            <NoticeGlossaryInput
                formikProps={formikProps}
                id={gId("state")}
                items={getDict("SL.MT.007")}
                required
                unmountOnExit
            />
        </Collapse>
        <NoticeGlossaryInput
            formikProps={formikProps}
            id={gId("nuts3")}
            items={getDict("SL.MT.004")}
            unmountOnExit
            prefixLabelsWithKeys
        />
        <NoticeTextInput
            formikProps={formikProps}
            id={gId("phone")}
        />
        <NoticeTextInput
            formikProps={formikProps}
            id={gId("fax")}
        />
        <NoticeTextInput
            formikProps={formikProps}
            id={gId("email")}
            required
        />
        <NoticeTextInput
            formikProps={formikProps}
            id={gId("www")}
            required
        />
    </>)
}

PurchaserDataEntrusted.propTypes = {};
export default PurchaserDataEntrusted;


